const selectLocalExercise = (state, id) => state.localExercises[id];
export default selectLocalExercise;